<template>
  <vs-popup :active.sync="open"
            :buttons-hidden="true"
            @close="onClickClose()"
            class="assign-formulation-stock-inventory-pop-up"
            title="ASSIGN FORMULATION STOCK INVENTORY">
    <vx-card no-shadow>
      <h5 class="mb-2 text-primary">Stock Available Quantity (kg): {{ completed_quantity }}</h5>
      <vs-table
        :data="items"
        :hoverFlat="true"
        id="assign-formulation-stock-inventory-pop-up"
        stripe>

        <template slot="thead">
          <vs-th>Product Order Code</vs-th>
          <vs-th>Pending Manufacturing Quantity (KG)</vs-th>
          <vs-th>Selected Quantity (KG)</vs-th>
          <vs-th>ACTION</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].product_order_code">
              {{ data[indextr].product_order_code }}
            </vs-td>

            <vs-td :data="data[indextr].pending_manufacture_quantity">
              {{ data[indextr].pending_manufacture_quantity }}
            </vs-td>

            <vs-td :data="data[indextr].selected_quantity">
              <div class="vx-row">
                <vs-input v-model="data[indextr].selected_quantity" class="w-full required" />
              </div>
            </vs-td>

            <vs-td>
              <div class="vx-row">
                <vx-tooltip class="ml-2" position="left" text="Assign">
                  <vs-button :disabled="isDisableAssignButton(data[indextr].selected_quantity)"  @click.stop="onClickAssign(data[indextr].id, data[indextr].selected_quantity)"
                             color="primary" icon="icon-share" icon-pack="feather" size="small"
                             type="filled"></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>

    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const ManufacturingRepository = RepositoryFactory.get('manufacturing');

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      items: [],
      formulation_id: '',
      inventory_id: '',
      completed_quantity: '',
      item_id: null
    }
  }

  export default {
    name: 'AssignFormulationStockPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(formulation_id, inventory_id, completed_quantity, item_id = null) {
        try {
          await Object.assign(this.$data, initialState());
          this.formulation_id = formulation_id;
          this.inventory_id = inventory_id;
          this.item_id = item_id
          this.completed_quantity = Number(completed_quantity).toFixed(4)
          this.open = true;
          await this.fetchFormulationItem()
        } catch (error) {

        }
      },
      onClickClose() {
        this.$emit('refreshData')
        this.open = false
      },
      async onClickAssign(id, quantity) {
        const vue = this
        await this.$vs.loading({
          container: '#assign-formulation-stock-inventory-pop-up',
          scale: 0.45
        })
         try {
           const payload = {
             formulation_id: this.formulation_id,
             customer_product_order_item_id: id,
             quantity: quantity,
             formulation_stock_inventory_id: this.inventory_id
           }
           await ManufacturingRepository.assignFormulationStock(payload)
           this.showSuccessMessage('Formulation item assigned to stock inventory')
           this.open = false;
           this.$emit('refreshData')
          //  await this.fetchFormulationItem()
           this.$vs.loading.close('#assign-formulation-stock-inventory-pop-up > .con-vs-loading')
         }catch (e) {

           this.$vs.loading.close('#assign-formulation-stock-inventory-pop-up > .con-vs-loading')
           this.convertAndNotifyError(e)
         }
      },
      async fetchFormulationItem() {
        await this.$vs.loading({
          container: '#assign-formulation-stock-inventory-pop-up',
          scale: 0.45
        });
        try {
          const {data} = (await ManufacturingRepository.getFormulationsOrderItems(this.formulation_id)).data;
          this.items = data.map((n) => {
            n.selected_quantity = 0
            return n
          })
          if(!!this.item_id) {
            this.items = this.items.filter((x) => this.item_id === x.id)
          }
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#assign-formulation-stock-inventory-pop-up > .con-vs-loading')
      },
      isDisableAssignButton(selected_qty) {
        return this.completed_quantity < Number(selected_qty) || Number(selected_qty) === 0
      }

    },
    async mounted() {

    },
    components: {
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .assign-formulation-stock-inventory-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }

</style>
